import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./../globalCSS/querytype/customquery.css";
import { useNavigate } from "react-router-dom";
import Header from "../header";
import Popupaddparameter from "./Popupaddparameter";
import PopupremoveDateParameter from "./PopupremoveDateParameter";
import { toast } from "react-toastify";
import {
  testquryonCustompage,
  resettestquryonCustompage,
  resetbacktocustomquerypagewithdata,
} from "../../actions/auth";
import {
  getReportDetailByID,
  getreporttitlefromondashbaord,
  texttoquerychartbotreset,
  removelistofcolumnformappingfirst,
  removelistofcolumnformappingsecond,
  defaultcheckdrilldown,
  setDrilldownTypeCheckdashboard,
} from "../../actions/reportmanagement";
import { Button } from "./../globalCSS/Button/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import ChatBotModal from "./ChatBotModal";
import bot from "../Images/bot.png";
import { decryptData } from "../utils/EncriptionStore";
import charts from './ChartGallery';
import { useRef } from "react";

export default function UpdateReportPage(props) {
  const insitialval = {
    title: "",
    query: "",
    start_date: "",
    end_date: "",
    type: "",
    chart_type: "",
    time_period: "",
    report_id: "",
    upload_logo: "",
    image_size: "",
    background_colour: "",
    chart_react_colour: "",
    font_size_title: "",
    font_size_value: "",
    layout: "",
    layout_value: "",
    gradient_mode: "",
    subtitle: "",
    subtitle_size: "",
    subtitle_color: "",
    text_alignment: "",
    chart_colours: "",
    enable_drilldown: "no",
    enable_range_filter: "no",
    drilldown_type: "",
    update_interval: "",
    chart_subtitle: "",
    enable_labels: "",
    custombox_background_colour: "",
    custombox_title_font_size: "",
    custombox_value_font_size: "",
    custombox_font_colour: "",
    custombox_legend_font_colour: "",
    custombox_legend_position: "",
    display_title: "",
  };



  const renderCharts = (chartList) =>
    chartList.map((chart) => (
      <div
        key={chart.id}
        style={{ cursor: "pointer" }}
      >
        <input
          className="radBut"
          type="radio"
          id={chart.id}
          name="chart_type"
          value={chart.value}
          onChange={handleRadioChange}
          title={chart.title}
        />
        <label htmlFor={chart.id} className="radio-inline">
          <img className="charts_img" src={chart.imageUrl} alt={chart.title} />
        </label>
      </div>
    ));
  const handleClose = () => {
    dispatch(texttoquerychartbotreset());
    setShowModal(true);
  };
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [showLogoSection, setShowLogoSection] = useState(false);
  const [formdata, setformdata] = useState(insitialval);
  const [enableDrilldown, setEnableDrilldown] = useState("no");
  const [enablerangefilter, setEnableRangeFilter] = useState("no");
  const [popupaddateparameter, setpopupaddateparameter] = useState(false);
  const [popupremoveateparameter, setpopuppopupremoveateparameter] = useState(false);
  const [popupremovedateparameter, setpopupremovedateparameter] = useState();
  const [isChartSelected, setIsChartSelected] = useState(false);
  const [isDrilldownSelected, setIsDrilldownSelected] = useState(false);
  const [ischeckstartdate, setischeckstartdate] = useState(true);
  const [ischeckenddate, setischeckenddate] = useState(false);
  const [checkuploadlogo, setCheckUploadLogo] = useState("");
  const [loading, setLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [messageShown, setMessageShown] = useState(false);

  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();

  const history = useNavigate(props);
  const dispatch = useDispatch();

  const queryParameters = new URLSearchParams(window.location.search);
  const report_id = queryParameters.get("report_id");
  const BuildQuery = queryParameters.get("Query");
  const [normalCustomQueryInputWidth, setNormalCustomQueryInputWidth] = useState(0);

  useEffect(() => {
    const normalCustomQueryInputDiv = document.getElementById(
      "normalCustomQueryInputId"
    );
    if (normalCustomQueryInputDiv) {
      const resizeObserver = new ResizeObserver(() => {
        const rect = normalCustomQueryInputDiv.getBoundingClientRect();
        setNormalCustomQueryInputWidth(rect.width);
      });

      resizeObserver.observe(normalCustomQueryInputDiv);
      return () => {
        resizeObserver.unobserve(normalCustomQueryInputDiv);
        resizeObserver.disconnect();
      };
    }
  }, []);

  useEffect(() => {
    if (report_id) {
      dispatch(
        getReportDetailByID({
          database_type: user.database_type,
          report_id: report_id,
          // chart_colours: `${reportdetail?.data?.chart_colours}`,
        })
      );
      setformdata({ ...formdata, report_id: report_id });
    } else if (BuildQuery) {
      setformdata({ ...formdata, query: BuildQuery });
    }
  }, [report_id, BuildQuery]);

  const handleUploadLogoChange = (event) => {
    const checklogouploaded = event.target.value;
    if (event.target.value === "yes") {
      setCheckUploadLogo(checklogouploaded);
    } else {
      localStorage.removeItem("uploadLogo");
      setCheckUploadLogo(checklogouploaded);
      setformdata((prevData) => ({
        ...prevData,
        upload_logo: null
      }))
    }

  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file && file.type === "image/png" && file.size <= 1048576) {
      // Convert file to base64-encoded string
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result;
        localStorage.setItem("uploadLogo", base64String);
      };
      reader.readAsDataURL(file);

      // setformdata({ ...formdata, upload_logo: file });
    } else {
      toast.success("Please select a PNG file with a maximum size of 1 MB.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    dispatch(
      getreporttitlefromondashbaord({
        database_type: user.database_type,
        email: user.user_email_id,
        customer_id: user.customer_id,
        group_id: user.group_id,
      })
    );
    dispatch(resettestquryonCustompage());
    dispatch(defaultcheckdrilldown());
    dispatch(removelistofcolumnformappingfirst());
    dispatch(removelistofcolumnformappingsecond());
  }, []);

  const apiData = useSelector((state) => state);

  const reportdetail = apiData?.reportmanagement.generate_detail_by_id;



  useEffect(() => {
    const reortdata = reportdetail?.data;

    const reportdetailBoxCustomizationOptions = JSON.parse(
      reortdata?.box_customization_options || "{}"
    );
    localStorage.setItem("SelectedSchema", JSON.stringify({ selectedSchema: reortdata?.schema_name, databasename: reortdata?.rdbms_name }));

    if (
      report_id === reortdata?.report_id.toString() &&
      reortdata?.report_type === "Box"
    ) {
      if (reortdata?.enable_drilldown === "yes") {
        setEnableDrilldown("yes");
      } else {
        setEnableDrilldown("no");
      }
      if (reortdata?.enable_range_filter === "yes") {
        setEnableRangeFilter("yes");
      } else {
        setEnableRangeFilter("no");
      }
      if (reortdata.upload_logo != null) {
        setCheckUploadLogo("yes");
        setShowLogoSection(true);
      } else {
        setCheckUploadLogo("no");
        setShowLogoSection(true);
      }
      setformdata((prevData) => ({
        ...prevData,
        title: reortdata?.report_template_name,
        query: reortdata?.defined_query,
        start_date: reortdata?.start_date,
        end_date: reortdata?.end_date,
        type: reortdata?.report_type,
        chart_type: reortdata?.chart_type,
        time_period: reortdata?.time_period,
        enable_range_filter: reortdata?.enable_range_filter,
        background_colour: reportdetailBoxCustomizationOptions?.background_colour,
        chart_react_colour: reportdetailBoxCustomizationOptions?.chart_react_colour,
        font_size_title: reportdetailBoxCustomizationOptions?.font_size_title,
        font_size_value: reportdetailBoxCustomizationOptions?.font_size_value,
        layout: reportdetailBoxCustomizationOptions?.layout,
        layout_value: reportdetailBoxCustomizationOptions?.layout_value,
        gradient_mode: reportdetailBoxCustomizationOptions?.gradient_mode,
        subtitle: reportdetailBoxCustomizationOptions?.subtitle,
        subtitle_text: reportdetailBoxCustomizationOptions?.subtitle_text,
        subtitle_size: reportdetailBoxCustomizationOptions?.subtitle_size,
        subtitle_color: reportdetailBoxCustomizationOptions?.subtitle_color,
        text_alignment: reportdetailBoxCustomizationOptions?.text_alignment,
        enable_drilldown: reortdata?.enable_drilldown,
        drilldown_type: reortdata?.drilldown_type || "",
        update_interval: reortdata?.auto_update_interval,
        connection_type: reortdata?.rdbms_name,
        schema: reortdata?.schema_name,
        upload_logo: reortdata?.upload_logo,
        image_size: reportdetailBoxCustomizationOptions?.image_size,
        display_title: reportdetailBoxCustomizationOptions?.display_title,
      }));
      // setformdata(editdata);
    } else if (
      report_id === reortdata?.report_id.toString() &&
      reortdata?.report_type === "Table"
    ) {
      setformdata((prevData) => ({
        ...prevData,
        title: reortdata?.report_template_name,
        query: reortdata?.defined_query,
        start_date: reortdata?.start_date,
        end_date: reortdata?.end_date,
        type: reortdata?.report_type,
        chart_type: reortdata?.chart_type,
        time_period: reortdata?.time_period,
        // show_dashboard: reortdata?.show_in_dashboard,
        enable_drilldown: reortdata?.enable_drilldown,
        update_interval: reortdata?.auto_update_interval,
        connection_type: reortdata?.rdbms_name,
        schema: reortdata?.schema_name,
      }));
    } else if (
      report_id === reortdata?.report_id.toString() &&
      reortdata?.report_type === "Chart"
    ) {
      if (reortdata?.enable_drilldown === "yes") {
        setEnableDrilldown("yes");
      } else {
        setEnableDrilldown("no");
      }
      if (reortdata?.enable_range_filter === "yes") {
        setEnableRangeFilter("yes");
      } else {
        setEnableRangeFilter("no");
      }
      setformdata((prevData) => ({
        ...prevData,
        title: reortdata?.report_template_name,
        query: reortdata?.defined_query,
        start_date: reortdata?.start_date,
        end_date: reortdata?.end_date,
        type: reortdata?.report_type,
        chart_type: reortdata?.chart_type,
        chart_colours: reortdata?.chart_colours,
        time_period: reortdata?.time_period,
        chart_subtitle: reortdata?.chart_subtitle,
        enable_labels: reortdata?.enable_labels,
        enable_drilldown: reortdata?.enable_drilldown,
        enable_range_filter: reortdata?.enable_range_filter,
        drilldown_type: reortdata?.drilldown_type || "",
        update_interval: reortdata?.auto_update_interval,
        connection_type: reortdata?.rdbms_name,
        schema: reortdata?.schema_name,
        custombox_background_colour: reortdata?.custombox_background_colour,
        custombox_title_font_size: reortdata?.custombox_title_font_size,
        custombox_value_font_size: reortdata?.custombox_value_font_size,
        custombox_font_colour: reortdata?.custombox_font_colour,
        custombox_legend_font_colour: reortdata?.custombox_legend_font_colour,
        custombox_legend_position: reortdata?.custombox_legend_position,
        display_title: reortdata?.display_title,
      }));
    }
  }, [reportdetail]);

  const blurOnQueryTextArea = () => {
    setMessageShown(!messageShown);
  };
  useEffect(() => { }, [isTyping]);

  useEffect(() => {
    const fetchQuery = async () => {
      if (
        reportdetail?.data?.rdbms_name &&
        reportdetail?.data?.schema_name &&
        !isTyping &&
        formdata.query // Ensure the query is not empty
      ) {
        try {
          setLoading(true)
          await dispatch(
            testquryonCustompage({
              query: formdata.query,
              schema: reportdetail?.data?.schema_name,
              email: user.user_email_id,
              connection_type: reportdetail?.data?.rdbms_name,
              database_type: user.database_type,
            })
          );
        } catch (error) {
          console.log(`Somthing wrong with Api ${error}`)
        } finally {
          setLoading(false)
        }
      }

    }
    fetchQuery()
  }, [reportdetail, formdata.query, user.user_email_id, isTyping]);


  useEffect(() => {
    if (formdata.type === "Table" || formdata.type === "Box") {
      setformdata((prevData) => ({
        ...prevData,
        chart_type: "",
      }));
      if (isChartSelected) {
        setIsChartSelected(false);
      }
    }
    if (formdata.type === "Table") {
      setEnableDrilldown("no");
      setEnableRangeFilter("no");
      setformdata((prevData) => ({
        ...prevData,
        enable_drilldown: "no",
        enable_range_filter: "no",
      }));
      if (isDrilldownSelected) {
        setIsDrilldownSelected(false);
      }
    }
  }, [formdata.type, isChartSelected, isDrilldownSelected]);

  const updateintervalset = (interval) => {
    const updateinterval = {
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
    };
    return updateinterval[interval];
  };

  const handleRadioChange = (event) => {
    const chartTypes = {
      "Bar Chart": "bar",
      "Column Chart": "column",
      "Line Chart": "line",
      "Gauge Chart": "gauge",
      "Area Chart": "area",
      "Pie Chart": "pie",
      "Radial Bar Chart": "radialBar",
      "Stacked Area Chart": "stackarea",
      "Stacked Bar Chart": "stackbar",
      "Stacked Column Chart": "stackcolumn",
      "3d Pie Chart": "3Dpie",
      "3d Donut Chart": "3D Donut",
      "3d Area Chart": "3Darea",
      "speedometer": "speedometer",
      "drillcolumn": "drillcolumn",
      "custombox": "custombox",

    };

    const selectedChartType = chartTypes[event.target.value];

    if (selectedChartType) {
      setformdata({ ...formdata, [event.target.name]: selectedChartType });
      setShow(false);
      setIsChartSelected(true);
    }
  };

  const handleSubmit = (e) => {
    dispatch(resetbacktocustomquerypagewithdata());
    dispatch(setDrilldownTypeCheckdashboard(false))
    e.preventDefault(formdata, "formdata");
    if (isTyping) {
      toast.success("Please test the query before previewing.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }
    if (formdata.title && formdata.query && formdata.type) {
      localStorage.setItem("customeDetailOfReport", JSON.stringify(formdata));
    } else {
      toast.success("Please fill the missing field value", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
    history("/PreviewPage");
  };

  const handleTestQuery = async (e) => {
    e.preventDefault();
    setIsTyping(!isTyping);
    if (reportdetail?.data?.rdbms_name && reportdetail?.data?.schema_name) {
      const query = formdata.query.trim().toLowerCase();
      if (query.startsWith("select") || query.startsWith("with")) {
        setLoading(true);
        try {
          await dispatch(
            testquryonCustompage({
              query: formdata.query,
              schema: reportdetail?.data?.schema_name,
              email: user.user_email_id,
              connection_type: reportdetail?.data?.rdbms_name,
              database_type: user.database_type,
            })
          );
        } catch (error) {
          console.error("Error executing query:", error);
        } finally {
          setLoading(false);
        }
      } else {
        toast.success("Only Select Operation is allowed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      }
    }
  };

  useEffect(() => {
    dispatch(resettestquryonCustompage());
  }, []);

  const validationQuery = apiData?.auth.test_custom_query;
  const focusOnQueryTextArea = () => {
    if (!messageShown) {
      setIsTyping(true);
      setShowMessage(true);
      setMessageShown(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    }
  };
  useEffect(() => {
    if (formdata?.type === "Table") setShow(false);
  }, [formdata?.type]);

  const renderConditionalCharts = () => {
    if (
      validationQuery?.statusCode === 200 &&
      validationQuery?.column_count === 1
    ) {
      const gaugeAndSpeedometerCharts = charts.filter(
        (chart) => chart.id === "gauge" || chart.id === "speedometer"
      );
      return (
        <div
          className="form-group radBut"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 50,
            justifyContent: "center",
          }}
        >
          {renderCharts(gaugeAndSpeedometerCharts)}
        </div>
      );
    } else {
      let chartList = charts.filter(
        (chart) => chart.id !== "gauge" && chart.id !== "speedometer"
      );

      const isPieChartAllowed =
        validationQuery?.statusCode === 200 &&
        validationQuery?.column_count === 2 &&
        ["TEXT", "VARCHAR"].includes(validationQuery?.column_type[1]) &&
        ["INT", "FLOAT"].includes(validationQuery?.column_type[2]);

      if (isPieChartAllowed) {
        const pieCharts = charts.filter(
          (chart) =>
            chart.id === "pie" &&
            chart.id === "3d pie" &&
            chart.id === "3d donut" &&
            chart.id === "donut" &&
            chart.id === "drillcolumn" &&
            chart.id === "custombox"
        );
        chartList = [...chartList, ...pieCharts];
      } else {
        chartList = chartList.filter(
          (chart) =>
            chart.id !== "pie" &&
            chart.id !== "3d pie" &&
            chart.id !== "3d donut" &&
            chart.id !== "donut" &&
            chart.id !== "drillcolumn" &&
            chart.id !== "custombox"
        );
      }

      return (
        <div
          className="form-group radBut"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 50,
            justifyContent: "center",
          }}
        >
          {renderCharts(chartList)}
        </div>
      );
    }
  };
  function handleChangecharttype() {
    // setchartType(event.target.value)
    setShow((prev) => !prev);
  }
  const handleChange = (e) => {
    const lowerType = formdata?.type?.toString?.().toLowerCase();
    const shouldLimit =
      ["title", "name", "report_template_name"].includes(e.target.name) &&
      lowerType === "box";

    if (shouldLimit) {
      if (e.target.value.length > 45) {
        toast.warn("Title cannot exceed 45 characters for Box type", {
          position: "top-right",
          autoClose: 3000,
        });
        return; // prevent update
      }
    }
    if (e.target.name === "query") {
      dispatch(resettestquryonCustompage());
      setformdata({ ...formdata, [e.target.name]: e.target.value });
    } else if (e.target.name === "update_interval") {
      const interval = updateintervalset(e.target.value);
      setformdata({ ...formdata, [e.target.name]: interval });
    } else {
      setformdata({ ...formdata, [e.target.name]: e.target.value });
    }
  };

  const handleReportTypeChange = (event) => {
    setformdata({ ...formdata, type: event.target.value });
    if (event.target.value === "Box") {
      setShowLogoSection(true);
    } else {
      setShowLogoSection(false);
    }
  };

  const handleEnableDrilldownChange = (event) => {
    const enableDrilldownValue = event.target.value;
    setEnableDrilldown(enableDrilldownValue);
    setformdata((prevData) => ({
      ...prevData,
      enable_drilldown: enableDrilldownValue,
    }));
  };

  const handleEnableRangeChange = (event) => {
    const enablerangevalue = event.target.value;
    setEnableRangeFilter(enablerangevalue);
    setformdata((prevData) => ({
      ...prevData,
      enable_range_filter: enablerangevalue,
    }));
  };


  const handleclickgotoDashboard = () => {
    history("/Dashboard");
  };

  const handleClickGoToReportManagement = () => {
    history("/ListOfReports");
  };


  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div style={{ overflow: "clip" }}>
      {popupaddateparameter && (
        <Popupaddparameter
          formdata={formdata}
          setformdata={setformdata}
          setpopupaddateparameter={setpopupaddateparameter}
          setischeckstartdate={setischeckstartdate}
          setischeckenddate={setischeckenddate}
        />
      )}
      {popupremoveateparameter && (
        <PopupremoveDateParameter
          formdata={formdata}
          setformdata={setformdata}
          setpopuppopupremoveateparameter={setpopuppopupremoveateparameter}
        />
      )}
      {showModal && (
        <ChatBotModal
          setShowModal={setShowModal}
          handleClose={handleClose}
          setformdata={setformdata}
        />
      )}
      <div>
        <Header />
      </div>
      <div className="Custom_container">
        <div className="Custom_header_container">
          <span
            class="fas fa-house-user"
            aria-hidden="true"
            onClick={handleclickgotoDashboard}
          ></span>
          <span>/</span>
          <span
            className="go-back-link-tag"
            onClick={handleClickGoToReportManagement}
            style={{ cursor: "pointer" }}
          >
            Report Management
          </span>
          <span>/</span>
          <span>Edit Report</span>
        </div>{" "}
        <div className="customformpage">
          <form className="well form-horizontal" id="report_management">
            <fieldset>
              <div class="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Title
                </label>
                <div className="col-md-5 inputGroupContainer">
                  <div className="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-heading"></i>
                    </span>
                    <input
                      name="title"
                      placeholder="e.g. Incident Severity"
                      className="form-control"
                      maxLength={38}
                      minLength={5}
                      type="text"
                      value={formdata.title}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Query
                </label>
                <div className="col-md-5 inputGroupContainer">
                  <div class="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-edit"></i>
                    </span>
                    <textarea
                      name="query"
                      placeholder="Query"
                      value={formdata.query}
                      className="form-control query-section-textarea"
                      onFocus={focusOnQueryTextArea}
                      onBlur={blurOnQueryTextArea}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
                <img
                  className="chart_bot_icon"
                  src={bot}
                  onClick={handleClose}
                  title="Write your query"
                />
                {showMessage && (
                  <div class="alert-for-update-custom-query">
                    <span class="alert-icon">⚠️</span>
                    <span class="alert-message">
                      Please click the test query button after typing to
                      validate your query.
                    </span>
                    <button class="close-btn" aria-label="Close alert">
                      &times;
                    </button>
                  </div>
                )}
              </div>
              <div className="mb-3 row col-md-5`input-group param_button">
                <Button
                  type="button"
                  disabled={validationQuery?.statusCode !== 200}
                  onClick={() => {
                    setpopupremovedateparameter();
                    setpopupaddateparameter(true);
                  }}
                >
                  Add Date Parameter
                </Button>

                <Button
                  type="button"
                  disabled={
                    !(
                      validationQuery?.statusCode === 200 &&
                      formdata.start_date !== "" &&
                      formdata.end_date !== ""
                    )
                  }
                  onClick={() => {
                    setpopupremovedateparameter();
                    setpopuppopupremoveateparameter(true);
                  }}
                >
                  Remove Date Parameter
                </Button>

                <Button type="button" onClick={handleTestQuery} >
                  {loading ? (
                    <span>
                      Testing...
                    </span>
                  ) : (
                    "Test Query"
                  )}
                </Button>
              </div>
              {/* </div> */}
              <div style={{ textAlign: "center" }}>
                {!isTyping &&
                  validationQuery &&
                  validationQuery?.detail === "Valid Query" ? (
                  <p>
                    <i
                      style={{
                        backgroundColor: "green",
                        fontSize: "18px",
                        width: "25px",
                        height: "15px",
                        borderRadius: "50%",
                      }}
                      class="fa-solid fa-check"
                    ></i>
                    {validationQuery?.detail}
                  </p>
                ) : validationQuery?.statusCode === 400 ||
                  validationQuery?.statusCode === 401 ? (
                  !isTyping &&
                  validationQuery && (
                    <p>
                      <i
                        style={{
                          backgroundColor: "red",
                          fontSize: "18px",
                          width: "25px",
                          height: "15px",
                          borderRadius: "50%",
                        }}
                        class="fa-solid fa-smark"
                      ></i>
                      <span>{validationQuery?.detail}</span>
                    </p>
                  )
                ) : (
                  !isTyping &&
                  validationQuery && (
                    <p>
                      <i
                        style={{
                          backgroundColor: "yellow",
                          fontSize: "18px",
                          width: "25px",
                          height: "15px",
                          borderRadius: "50%",
                        }}
                        class="fa-solid fa-smark"
                      ></i>
                      {validationQuery?.detail}
                    </p>
                  )
                )}
              </div>
              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Start Date
                </label>
                <div
                  className="col-md-5 inputGroupContainer"
                  id="normalCustomQueryInputId"
                >
                  <div class="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-calendar"></i>
                    </span>
                    <input
                      type="date"
                      name="start_date"
                      class="form-control"
                      disabled={ischeckstartdate}
                      placeholder="Start Date"
                      aria-label="Username"
                      aria-describedby="addon-wrapping"
                      value={formdata.start_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  End Date
                </label>
                <div className="col-md-5 inputGroupContainer">
                  <div class="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-calendar"></i>
                    </span>
                    <input
                      type="date"
                      name="end_date"
                      class="form-control"
                      disabled={ischeckstartdate}
                      placeholder="end_date"
                      aria-label="Username"
                      aria-describedby="addon-wrapping"
                      value={formdata.end_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Type
                </label>
                <div className="col-md-5 selectContainer">
                  <div class="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-file-alt"></i>
                    </span>
                    <select
                      name="type"
                      className="form-control selectpicker"
                      disabled={validationQuery?.statusCode != 200}
                      onChange={handleReportTypeChange}
                      value={formdata.type}
                      required
                    >
                      <option value="" disabled selected hidden>
                        Report Type
                      </option>
                      {validationQuery?.statusCode === 200 &&
                        validationQuery?.column_count > 1 && (
                          <>
                            <option>Table</option>
                            <option>Chart</option>
                          </>
                        )}
                      {validationQuery?.statusCode === 200 &&
                        validationQuery?.column_count === 1 && (
                          <>
                            <option>Box</option>
                            <option>Chart</option>
                          </>
                        )}
                    </select>
                  </div>
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Chart Type
                </label>
                <div className="col-md-5 selectContainer">
                  <div className="input-group flex-nowrap" ref={wrapperRef}>
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-chart-bar"></i>
                    </span>
                    <div style={{ minWidth: normalCustomQueryInputWidth - 56 }}>
                      <textarea
                        name="chart_type"
                        value={formdata.chart_type}
                        className="form-control textArea-chart-type"
                        onClick={handleChangecharttype}
                        placeholder="Chart Type"
                        required={
                          formdata.type !== "Table" && formdata.type !== "Box"
                        }
                        disabled={
                          formdata.type !== "Chart"
                        }
                        style={{
                          height: "34px",
                          resize: true,
                          width: "100%",
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                        }}
                      ></textarea>
                      {show && <div> {renderConditionalCharts()}</div>}
                    </div>
                  </div>
                </div>
              </div>

              {(formdata.type === "Chart" || formdata.type === "Box") && (
                <div className="mb-3 row">
                  <label className="col-md-4 control-label testalinritemval">
                    Enable Drilldown
                  </label>
                  <div className="radio col-md-2 display_radio">
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="enableDrilldown"
                        value="yes"
                        onChange={handleEnableDrilldownChange}
                        checked={
                          enableDrilldown === "yes" ||
                          formdata.enable_drilldown === "yes"
                        }
                        disabled={
                          !(
                            formdata.type === "Box" ||
                            formdata.query.toLowerCase().includes("group by")
                          )
                        }
                      />{" "}
                      Yes
                    </label>
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="enableDrilldown"
                        value="no"
                        onChange={handleEnableDrilldownChange}
                        checked={
                          enableDrilldown === "no" ||
                          formdata.enable_drilldown === "no"
                        }
                        disabled={
                          !(
                            formdata.type === "Box" ||
                            formdata.query.toLowerCase().includes("group by")
                          )
                        }
                      />{" "}
                      No
                    </label>
                  </div>
                </div>
              )}
              {(formdata.type === "Chart" || formdata.type === "Box") && (
                <div className="mb-3 row">
                  <label className="col-md-4 control-label testalinritemval">
                    Enable Range Filter
                  </label>
                  <div className="radio col-md-2 display_radio">
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="enablerangefilter"
                        value="yes"
                        onChange={handleEnableRangeChange}
                        checked={
                          enablerangefilter === "yes" ||
                          formdata.enable_range_filter === "yes"
                        }
                        disabled={
                          !(
                            formdata.type === "Box" ||
                            formdata.query.toLowerCase().includes("group by")
                          )
                        }
                      />{" "}
                      Yes
                    </label>
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="enablerangefilter"
                        value="no"
                        onChange={handleEnableRangeChange}
                        checked={
                          enablerangefilter === "no" ||
                          formdata.enable_range_filter === "no"
                        }
                        disabled={
                          !(
                            formdata.type === "Box" ||
                            formdata.query.toLowerCase().includes("group by")
                          )
                        }
                      />{" "}
                      No
                    </label>
                  </div>
                </div>
              )}
              {showLogoSection && formdata.type === "Box" && (
                <div className="mb-3 row" style={{ alignItems: "center" }}>
                  <label className="col-md-4 control-label testalinritemval">
                    Upload logo
                  </label>
                  <div className="radio col-md-2 display_radio">
                    <label className="radio-inline">
                      <input
                        type="radio"
                        checked={checkuploadlogo === "yes"}
                        name="hosting3"
                        value="yes"
                        onChange={handleUploadLogoChange}
                      />{" "}
                      Yes
                    </label>
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="hosting3"
                        checked={checkuploadlogo === "no"}
                        value="no"
                        onChange={handleUploadLogoChange}
                      />{" "}
                      No
                    </label>
                    {checkuploadlogo === "yes" && (
                      <label>
                        <input
                          name="file"
                          onChange={handleFileChange}
                          type="file"
                          accept="image/png"
                        />
                      </label>
                    )}
                  </div>
                </div>
              )}
              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Auto Update Interval
                </label>
                <div className="col-md-5 selectContainer">
                  <div className="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-hourglass-half"></i>
                    </span>

                    <select
                      name="update_interval"
                      required
                      className="form-control selectpicker"
                      disabled={validationQuery?.statusCode != 200}
                      value={formdata.update_interval}
                      onChange={handleChange}
                    >
                      <option value="" disabled hidden>
                        Minute(s)
                      </option>
                      <option value="1">1 minute</option>
                      <option value="2">2 minutes</option>
                      <option value="3">3 minutes</option>
                      <option value="4">4 minutes</option>
                      <option value="5">5 minutes</option>
                    </select>
                  </div>
                </div>
              </div>
              {/* )} */}

              <div className="mb-3 row" style={{ justifyContent: "center" }}>
                <div className="col-md-4" style={{ paddingLeft: "125px" }}>
                  <Button
                    disabled={validationQuery?.statusCode != 200}
                    type="submit"
                    onClick={handleSubmit}
                  >
                    Preview
                  </Button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
}
